import React from 'react'
import { Tag, TagLabel } from '@chakra-ui/react'

function RoleTag({role, ...props}) {
    return (
        <Tag {...props}>
            <TagLabel whiteSpace='nowrap'>{role?.title}</TagLabel>
        </Tag>
    )
}

export default RoleTag
